import React, {useState} from 'react';
import DragDropContainer from '../DragDrop/DragDropContainer';
import '../AskWord/AskWord.css';
import Text from '../Text/Text';
import { setTimeout } from 'timers';

const AskWord  = (props)=>{
    const [className, setClassName] = useState(props.className); 
     
    const dragged = ()=> {
       setClassName('askWord beginWord');
        if (props.fake) {
            setClassName('askWord fakeWord');
            setTimeout(setClassName, 3000, 'askWord beginWord');
        };
    };
    return ( <DragDropContainer  targetKey = {props.targetKey}  
            onDragStart = {() => { setClassName('askWord dragWord');}} 
            onDragEnd = {dragged}>
            <div className = {className} style = {{top: props.top, left: props.left, width: props.width}} >
                <Text value = {props.value} /> 
             </div>
        </DragDropContainer>
    );

};
export default AskWord;